/*
 * @Descripttion: 
 * @version: 
 * @Author: Ray
 * @Date: 2024-03-12 13:23:11
 * @LastEditors: Ray
 * @LastEditTime: 2024-03-22 11:14:55
 */
import axios from 'axios';
import responseHistoryReport from './manage.js';
export function report(optionsData) {
    axios.interceptors.response.use(function (response) {
        const options = optionsData || {};
        const { msgCode = "100", whiteList = [], blackList = [], apikey = "" } = options || {};
        const reportData = {
            res: response,
            msgCode,
            whiteList,
            blackList,
            apikey
        };
        responseHistoryReport(reportData);
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
}

export function reportRequet(optionsData){
    var open = window.XMLHttpRequest.prototype.open;
    var send = window.XMLHttpRequest.prototype.send;
    let requestData = null;
    window.XMLHttpRequest.prototype.open = function() {
        // 保存原始的回调函数
        var originalOnReadyStateChange = this.onreadystatechange;
        // 替换 onreadystatechange 事件处理器
        this.onreadystatechange = function() {
            // 如果原始的 onreadystatechange 存在，先调用它
            if (originalOnReadyStateChange) {
                originalOnReadyStateChange.call(this);
            }
            // 在这里添加你自己的逻辑
            if (this.readyState == 4 && this.mito_xhr) {
                const options = optionsData || {};
                const { msgCode = "100", whiteList = [], blackList = [], apikey = "" } = options || {};
                const reportData = {
                    res: this,
                    requestData,
                    msgCode,
                    whiteList,
                    blackList,
                    apikey
                };
                responseHistoryReport(reportData);
            }
        };
        // 调用原始的 open 方法
        open.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function(data) {
        // 在发送请求前，将请求数据保存在实例的一个属性上
        requestData = data;
        // 调用原始的 send 方法
        send.apply(this, arguments);
    };
}

